import { Link } from 'react-router-dom'

import { trackCta, trackNav } from '@/lib/analytics'
import GlassSurface from './glass-surface'

export function Nav() {
  return (
    <nav className="fixed top-0 right-0 left-0 z-50 pt-6">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <GlassSurface
          width="100%"
          height={64}
          borderRadius={32}
          brightness={50}
          opacity={0.7}
          blur={16}
          displace={5}
          distortionScale={-150}
          redOffset={5}
          greenOffset={15}
          blueOffset={25}
          mixBlendMode="screen"
          className="w-full border border-white/10"
        >
          <div className="flex w-full items-center justify-between gap-8 px-6 py-3">
            <Link
              to="/"
              onClick={() => trackNav('logo')}
              className="group flex items-center gap-3 text-white transition-all duration-300"
            >
              <img
                src="/images/Harmonie-Media-Logo.svg"
                alt="Harmonie Media"
                className="h-8 w-8 invert transition-transform group-hover:scale-110"
              />
              <div className="font-montserrat">
                <div className="text-sm font-semibold">Harmonie Media</div>
              </div>
            </Link>

            <div className="flex items-center gap-6">
              <div className="hidden items-center gap-6 md:flex">
                <Link
                  to="/impressum"
                  onClick={() => trackNav('impressum')}
                  className="text-sm font-medium text-white/80 transition-colors duration-300 hover:text-purple-300"
                >
                  Impressum
                </Link>
                <Link
                  to="/datenschutz"
                  onClick={() => trackNav('datenschutz')}
                  className="text-sm font-medium text-white/80 transition-colors duration-300 hover:text-purple-300"
                >
                  Datenschutz
                </Link>
              </div>

              <Link
                to="/kontakt"
                onClick={() => trackCta('Kontakt', 'nav')}
                className="rounded-full bg-purple-600 px-3 py-2 text-sm font-medium text-white transition-all duration-300 hover:scale-105 hover:bg-purple-500 sm:px-4"
              >
                <span className="hidden sm:inline">Kontakt</span>
                <span className="sm:hidden" aria-hidden="true">
                  ✉
                </span>
                <span className="sr-only sm:hidden">Kontakt</span>
              </Link>
            </div>
          </div>
        </GlassSurface>
      </div>
    </nav>
  )
}
